import React from "react";
import Button from "@mui/material/Button";

const InstallButton = () => {
  return (
    <React.Fragment>
      <Button variant="contained" color="primary" sx={{ padding: "10px" }}>
        Install App
      </Button>
    </React.Fragment>
  );
};

export default InstallButton;
